import { useQuery } from "@tanstack/react-query";
import { getLeadTracks } from "../api";
import { GetLeadTracksParams } from "../dtos";

export const LEAD_TRACKS_QUERY_KEY = "leadTracks";

interface UseLeadTracksOptions extends GetLeadTracksParams {
  enabled?: boolean;
}

export const useLeadTracks = ({
  leadUId,
  developerUId,
  search,
  page = 1,
  pageSize = 50,
  enabled = true,
}: UseLeadTracksOptions) => {
  return useQuery({
    queryKey: [LEAD_TRACKS_QUERY_KEY, leadUId, developerUId, search, page, pageSize],
    queryFn: async () => {
      const response = await getLeadTracks({
        leadUId,
        developerUId,
        search,
        page,
        pageSize,
      });
      return response.data;
    },
    enabled: enabled && !!leadUId,
    staleTime: 30000, // 30 seconds
  });
};

export default useLeadTracks;

